import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import { CheckCircleIcon, ClockIcon, PlayCircleIcon } from "@heroicons/react/24/outline";
import { ChartBarIcon } from "@heroicons/react/24/outline";
import { SparklesIcon } from "@heroicons/react/24/outline";
import { useContext } from "react";
import { UserContext } from "../contexts/userContext";

export default function Home() {

    const [user, dispatch] = useContext(UserContext);
    const nav = useNavigate();

    return (
        <>
            <Helmet>
                <title>Habit Tracker - Trang chủ</title>
            </Helmet>

            <div className="bg-gray-100 min-h-screen pt-20">

                {/* HERO */}
                <div className="max-w-3xl mx-auto text-center mb-20 px-4">
                    <h1 className="text-4xl font-bold mb-4">
                        {user ? (
                            <>
                                Chào mừng{" "}
                                <span className="text-red-600">{user.full_name}</span>
                                {" "}đến với Habit Tracker
                            </>
                        ) : (
                            "Chào mừng đến với Habit Tracker"
                        )}
                    </h1>

                    <p className="text-lg text-gray-600 mb-8">
                        Xây dựng thói quen tốt mỗi ngày. Theo dõi – phân tích – cải thiện bản thân.
                    </p>

                    <div className="flex justify-center gap-4">
                        {!user ? (
                            <>
                                <Link
                                    to="/signup"
                                    className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700"
                                >
                                    Bắt đầu ngay
                                </Link>

                                <Link
                                    to="/login"
                                    className="px-6 py-3 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50"
                                >
                                    Đăng nhập
                                </Link>
                            </>
                        ) : (
                            <div className="flex justify-center gap-4">
                                <Link to="/dashboard" className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700">
                                    Đi đến Dashboard
                                </Link>
                                <button
                                    onClick={() => {
                                        localStorage.removeItem("user_data");
                                        dispatch({ type: "LOGOUT" });
                                    }}
                                    className="px-6 py-3 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50"
                                >
                                    Đăng xuất
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="max-w-5xl mx-auto mb-24 px-4">
                    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-green-500 to-emerald-600 p-8 text-white shadow-lg">
                        <div className="absolute -top-12 -right-12 w-48 h-48 bg-white/20 rounded-full blur-3xl"></div>
                        <div className="relative flex flex-col md:flex-row items-center justify-between gap-6">
                            <div className="flex items-start gap-4">
                                <ClockIcon className="w-12 h-12 text-white/90 flex-shrink-0" />
                                <div>
                                    <h2 className="text-2xl md:text-3xl font-bold mb-2">
                                        Focus Mode – Pomodoro
                                    </h2>
                                    <p className="text-white/90 max-w-xl">
                                        Sử dụng phương pháp Pomodoro để duy trì sự tập trung:
                                        làm việc 25 phút, nghỉ 5 phút, giúp bạn học tập và làm việc hiệu quả hơn.
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={() => nav("/focus")}
                                className="flex items-center gap-2 px-6 py-3 bg-white text-green-600 font-semibold rounded-xl shadow
                           hover:bg-gray-100 transition"
                            >
                                <PlayCircleIcon className="w-6 h-6" />
                                Sử dụng Pomodoro
                            </button>
                        </div>
                    </div>
                </div>

                {/* FEATURES */}
                <div className="max-w-6xl mx-auto px-4 pb-20 grid grid-cols-1 md:grid-cols-3 gap-6">
                    <FeatureCard
                        icon={<CheckCircleIcon className="w-12 h-12 text-blue-600 mx-auto mb-3" />}
                        title="Theo dõi thói quen"
                        desc="Ghi lại các thói quen mỗi ngày, giúp bạn duy trì sự ổn định."
                    />

                    <FeatureCard
                        icon={<ChartBarIcon className="w-12 h-12 text-blue-600 mx-auto mb-3" />}
                        title="Thống kê chi tiết"
                        desc="Biểu đồ và số liệu giúp bạn hiểu rõ tiến trình của mình."
                    />

                    <FeatureCard
                        icon={<SparklesIcon className="w-12 h-12 text-blue-600 mx-auto mb-3" />}
                        title="Phát triển bản thân"
                        desc="Thay đổi cuộc sống từng bước, bắt đầu từ thói quen nhỏ."
                    />
                </div>
            </div>
        </>
    );
}

function FeatureCard({ icon, title, desc }) {
    return (
        <div className="bg-white p-6 rounded-xl shadow text-center">
            {icon}
            <h3 className="text-lg font-semibold">{title}</h3>
            <p className="text-gray-600 mt-1">{desc}</p>
        </div>
    );
}